import styled from 'styled-components'
import { cyberColors } from '../../lib/colors'

export const PageWrapper = styled.div`
  padding: 14px 0 0;
  margin-bottom: 30px;
`
export const Page = styled.div`
  color: ${cyberColors.greyText};
  font-size: 22px;
  margin: 16px 0;
  text-transform: capitalize;
  cursor: pointer;
  opacity: 1;
  transition: all 0.167s;
  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
  :active,
  :hover {
    opacity: 0.5;
    transition: all 0.167s;
    transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
  }
`
